<div class="custom-table overflow-x-auto">
	<table class="mat-elevation-z8 bg-transparent w-full relative">
		<thead class="bg-light">
			<tr class="border-b-[1px] border-secondry-color-Gray">
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'POINTING_SYSTEM.POINTS_LIST.CLIENT_NAME' | translate }}
				</td>

				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'POINTING_SYSTEM.POINTS_LIST.ACTION' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center"
				>
					{{ 'POINTING_SYSTEM.POINTS_LIST.NUMBER_OF_POINTS' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'POINTING_SYSTEM.POINTS_LIST.DATE_TIME' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'POINTING_SYSTEM.POINTS_LIST.STATUS' | translate }}
				</td>
				<td></td>
			</tr>
		</thead>
		<tbody class="bg-grey-background">
			<tr
				*ngFor="
					let item of pointsHistoryList
						| paginate
							: {
									itemsPerPage: filter?.paging?.pageSize,
									currentPage: filter?.paging?.pageNumber,
									totalItems: totalCount
							  };
					let indx = index
				"
				class="{{
					indx + 1 != pointsHistoryList?.length
						? 'border-b-[1px] border-secondry-color-Gray'
						: ''
				}}"
			>
				<td
					[routerLink]="'/layout/clients/client-profile/' + item.clientId"
					class="cursor-pointer text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ item?.clientName }}
				</td>

				<td
					class="text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] max-mobile:px-padding-mobile-14 whitespace-nowrap font-Poppins-regular"
				>
					<h1 class="text-font-16 text-dark-grey max-mobile:text-font-12">
						{{
							translate.currentLang == 'en'
								? item?.actionName?.en
								: item?.actionName?.ar
						}}
					</h1>
				</td>
				<td class="text-center">
					<h1 class="text-font-16 text-dark-grey max-mobile:text-font-12">
						{{ item?.numberOfPoints }}
					</h1>
				</td>
				<td
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<p class="text-font-16 text-dark-grey">
						{{ item?.pointingDate | date : 'dd/MM/yyyy' : 'UTC' }}
					</p>
					<p class="text-font-14 text-medium-gray">
						{{ item?.pointingDate | date : 'hh:mm a' : 'UTC' }}
					</p>
				</td>
				<td
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<app-status
						[enumData]="pointsStatusEnum"
						[statusValue]="item?.status"
					></app-status>
				</td>
				<td
					class="text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<a
						[routerLink]="'/layout/clients/client-profile/' + item.clientId"
						class="inline-block max-mobile:w-[20px] w-[16px] text-end"
					>
						<img
							[src]="'assets/images/view.svg'"
							alt=""
							class="inline-block cursor-pointer"
						/>
					</a>
				</td>
			</tr>
		</tbody>
	</table>
</div>
